const periods = [
    { admisionMonth: 12, regularMonth: 1, term: "I", months: "FEBRERO-MAYO" },
    { admisionMonth: 3, regularMonth: 4, term: "II", months: "MAYO-AGOSTO" },
    { admisionMonth: 7, regularMonth: 8, term: "III", months: "SEPTIEMBRE-DICIEMBRE" },
];

export function getInscriptionPeriod() {
    const now = new Date();
    const currentMonth = now.getUTCMonth() + 1;
    let currentPeriod = periods[0];
    let year = now.getUTCFullYear();

    if (currentMonth >= 3 && currentMonth < 7) {
        currentPeriod = periods[1];
    } else if (currentMonth >= 7 && currentMonth < 12) {
        currentPeriod = periods[2];
    } else if (currentMonth === 12) {
        year++;
    }

    let validAdmision = currentPeriod.admisionMonth === 12 && currentMonth < 3;
    let admision = validAdmision || (currentMonth >= currentPeriod.admisionMonth && currentMonth < currentPeriod.admisionMonth + 3);
    let regular = currentMonth >= currentPeriod.regularMonth && currentMonth < currentPeriod.regularMonth + 2;
    let endedInscriptions = !admision && !regular;

    return {
        label: `${year}-${currentPeriod.term}`,
        months: currentPeriod.months,
        admision,
        endedInscriptions,
        regular,
        year
    }
}
